import React, { lazy, Suspense } from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import ReportPageAction from "../page-action/ReportPageAction";
import { commonText, customerRepoDtls } from "../../../locales/en";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";
const CustomerRepDetailsTable = lazy(
  () =>
    import(
      "../../../components/table/all-tables/reportable/customerdetails/CustomerRepDetailsTable"
    )
);

export default function CustomerRepoDetails() {
  return (
    <>
      <TablePagesTitle mainTitle={customerRepoDtls?.main_title} />

      <ReportPageAction subheading={customerRepoDtls?.main_title} />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-4 mb-2 mx-0 ">
          <div className="col-md-12">
            <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
              <CustomerRepDetailsTable />
            </Suspense>
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
